import { decode } from 'html-entities';

export const renderLegacyIdoHtml = (value: unknown): string => {
	if (value === null || value === undefined) {
		return '';
	}
	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
		return decode(String(value));
	}
	return '';
};

export const renderLegacyIdoHtmlLabel = (label: unknown): string => {
	return renderLegacyIdoHtml(label);
};

export const renderLegacyIdoPlainLabel = (label: unknown): string => {
	return decode(
		renderLegacyIdoHtml(label)
			.replace(/<br\s*\/?>/gi, ' ')
			.replace(/<[^>]*>/g, '')
	)
		.replace(/\s+/g, ' ')
		.trim();
};

export const renderLegacyIdoTableCellHtml = (value: unknown): string => {
	const renderedValue = renderLegacyIdoHtml(value);
	return renderedValue === '' ? '&nbsp;' : renderedValue;
};
